module.exports = "<c-hero></c-hero>\n<app-banner class=\"wContainer\"></app-banner>\n<!-- <div class=\"wContainer\">\n   <app-R1></app-R1>\n</div> -->\n<div class=\"wContainer\">\n   <c-news></c-news>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main